import React from 'react';

import { useSelector } from 'react-redux';

import {
    Button,
} from 'reaxl';
import { sendClick } from 'reaxl-analytics';

import offsetCalc from '@/utilities/offSetScrollCalculation';
import scrollToElement from '@/utilities/scrollToElement';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

function BatteryDegradationJumpLink({ ctaCopy = 'See Details' }) {
    const { electricComponentInfo = {} } = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const batteryRangeInfo = electricComponentInfo?.batteryRange;
    const batteryDetails = batteryRangeInfo !== undefined ? `${batteryRangeInfo} mi. when new.` : '';
    const handleBatteryDegradationClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollToElement('batteryHealthSection', offsetCalc(25, 'sticky-header-vdp'));
        sendClick('electricVehicleViewDetailsBatteryDegradationClick', e, {});
    };

    const batteryRangeTxt = batteryDetails && (
        <span className="text-gray text-normal">{batteryDetails}</span>
    );

    return (
        <>
            {batteryRangeTxt}
            <Button
                bsStyle="text"
                data-cmp="batteryDegradationInBtn"
                className="text-normal"
                onClick={handleBatteryDegradationClick}
            >
                {ctaCopy}
            </Button>
        </>
    );
}

export default BatteryDegradationJumpLink;
